<div
  class="modal fade"
  [class.show]="visible"
  [style.display]="visible ? 'block' : 'none'"
  tabindex="-1"
  role="dialog"
>
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fa fa-user-circle me-2 text-primary"></i>User Information
        </h5>
        <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <div class="row mb-3">
          <div class="col-md-5">
            <div class="row">
              <div class="col-md-4 text-center">
                <img
                  [src]="'assets/IMG/default-user.png'"
                  class="rounded-circle border"
                  width="100"
                  height="100"
                />
              </div>
              <div class="col-md-8">
                <h5 class="mb-1">{{ user.userName }}</h5>
                <p class="text-muted mb-2">{{ user.userLongname }}</p>
              </div>
            </div>
            <ul class="list-group">
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span><i class="fa fa-envelope me-2 text-primary"></i>Email</span>
                <span class="fw-semibold">{{ user.emailId }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span><i class="fa fa-phone me-2 text-primary"></i>Phone</span>
                <span class="fw-semibold">{{ user.mobileno }}</span>
              </li>
            </ul>
          </div>
          <div class="col-md-1 d-flex justify-content-center">
            <div style="width: 1px; background-color: #dee2e6; height: 100%"></div>
          </div>
          <div class="col-md-6">
            <p class="fw-bold mb-2">Permission</p>
            <ul class="list-group shadow-sm">
              @for (item of activities; track item.key) {
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span>
                  <i class="fa fa-check-circle me-2 text-primary"></i>
                  {{ item.label }}
                </span>
                <span
                  class="fw-semibold"
                  [class]="{
                    'text-success': entryAtivities[item.key] == 1,
                    'text-danger': entryAtivities[item.key] != 1
                  }"
                >
                  {{ entryAtivities[item.key] == 1 ? 'Yes' : 'No' }}
                </span>
              </li>
              }
              <li class="list-group-item">
                <strong>Modules:</strong>
                {{ modules?.length ? modules.join(', ') : 'No modules assigned' }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
      </div>
    </div>
  </div>
</div>
